import { render, staticRenderFns } from "./ModalPanel.vue?vue&type=template&id=d9d890d6&scoped=true&"
import script from "./ModalPanel.vue?vue&type=script&lang=js&"
export * from "./ModalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d890d6",
  null
  
)

export default component.exports